import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import { CiShoppingCart, CiUser, CiHeart } from "react-icons/ci";
import logo from "../assets/logoL.png";
import { BsCartX } from "react-icons/bs";
import { CartContext } from "../CartContext"; // Ensure CartContext is defined
import CartProduct from "./CartProduct"; // Ensure CartProduct component is defined
import { useAuth } from "../context/AuthContext";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const cart = useContext(CartContext);
  const { currentUser } = useAuth();
  const [toggle, setToggle] = useState(false);
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("home");
  const [totalCost, setTotalCost] = useState(0);
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();
  const productsCount = cart.items.reduce(
    (sum, product) => sum + product.quantity,
    0
  );

  const handleToggle = () => setToggle(!toggle);

  useEffect(() => {
    if (pathname === "/") {
      setActiveTab("home");
    } else if (pathname === "/produktet") {
      setActiveTab("produktet");
    } else if (pathname === "/kontakti") {
      setActiveTab("kontakti");
    }
  }, [pathname]);

  useEffect(() => {
    const fetchTotalCost = async () => {
      const cost = await cart.getTotalCost();
      setTotalCost(cost);
    };

    fetchTotalCost();
  }, [cart.items]); // Update when cart items change

  const subtotal = cart.items.reduce(
    (sum, product) => sum + product.quantity * product.price,
    0
  );

  return (
    <Container>
      <div className="mobile-menu" onClick={handleToggle}>
        {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
      </div>
      <Link to={"/"} className="link-styles">
        <img src={logo} alt="" className="logo" />
      </Link>
      <div className="icons">
        <span className="lg">
          <LanguageSelector />
        </span>
        <span>
          <CiShoppingCart
            onClick={() => setModal(!modal)}
            className="icon cartIcon"
          />
          <h4>{productsCount}</h4>
        </span>
        <span>
          <Link to={currentUser ? "wishlist" : "login"} className="link-styles">
            <CiHeart className="icon" />
          </Link>
        </span>
        <span>
          <Link to={currentUser ? "account" : "login"} className="link-styles">
            <CiUser className="icon" />
          </Link>
        </span>
      </div>
      <nav className={`sidebar ${toggle ? "active" : ""}`}>
        <ul>
          <li className={activeTab === "home" ? "activeTab" : ""}>
            <Link to="/" className="link-styles" onClick={handleToggle}>
              {t("navHome")}
            </Link>
          </li>
          <li className={activeTab === "produktet" ? "activeTab" : ""}>
            <Link
              to="/produktet"
              className="link-styles"
              onClick={handleToggle}
            >
              {t("navProducts")}
            </Link>
          </li>
          <li className={activeTab === "kontakti" ? "activeTab" : ""}>
            <Link to="/kontakti" className="link-styles" onClick={handleToggle}>
              {t("navContact")}
            </Link>
          </li>
        </ul>
      </nav>
      <div className={modal ? "modal" : "closedModal"}>
        <span>
          <div>
            <CiShoppingCart className="icon" />
            <h3>
              {t("cart")} ({productsCount})
            </h3>
          </div>
          <button className="x" onClick={() => setModal(false)}>
            <FaTimes />
          </button>
        </span>
        <div className="items">
          {cart.items.length > 0 ? (
            cart.items.map((item, index) => (
              <div className="item">
                <CartProduct
                  key={index}
                  id={item.id}
                  quantity={item.quantity}
                  selectedSize={item.size}
                  price={item.price}
                />
                <hr />
              </div>
            ))
          ) : (
            <p>{t("emptyCart")}</p>
          )}
        </div>
        {productsCount !== 0 && (
          <>
            <h2 className="totalPrice">
              {t("totalPrice")}: {subtotal.toFixed(2)} €
            </h2>
            <Link to={"/checkout"} className="link-styles">
              <button onClick={() => setModal(false)}>{t("checkout")}</button>
            </Link>
          </>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  background: #1f1f1f6c;
  transition: 0.7s;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1% 4%;
  width: 100%;
  height: 70px;
  z-index: 100;
  box-sizing: border-box;
  .logo {
    height: 55px;
  }
  .closedMenu {
    opacity: 0;
  }
  .navMenu {
    position: absolute;
    background: #303030;
    display: flex;
    justify-content: center;
    opacity: 0.5;
    align-items: center;
    top: 7px;
    left: 7px;
    padding: 30px 50px;
    height: 50vh;
    border-radius: 20px;
    box-shadow: 0 0 13px 2px #696969;
    .icon {
      top: 12px;
      left: 12px;
      cursor: pointer;
      z-index: 9999;
      font-size: 1.6em;
      position: absolute;
    }
    ul {
      display: flex;
      flex-direction: column;
      gap: 1em;
    }
  }
  .icons {
    display: flex;
    gap: 1em;
    .lg {
      margin-top: 4px;
    }
    span {
      position: relative;
      h4 {
        position: absolute;
        top: 0;
        background: #383838;
        padding: 2px 7px;
        border-radius: 50%;
        right: 0;
        font-weight: 300;
      }
      .icon {
        font-size: 2.2em;
        margin-top: 10px;
        cursor: pointer;
      }
      .cartIcon {
        margin-top: 8px;
        font-size: 2.7em;
      }
    }
    /* .icon {
      font-size: 2em;
      cursor: pointer;
    } */
  }
  .sidebar {
    display: none;
  }
  .sidebar.active {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    height: 50vh;
    border-radius: 0 0 20px 0;
    box-shadow: 0 0 13px 2px #1d1d1d;
    width: 250px;
    background: #303030;
    z-index: 999;
    transform: translateX(0);
    transition: transform 0.3s ease-in-out;
    ul {
      display: flex;
      flex-direction: column;
      padding-top: 70px;
      list-style: none;
      li {
        padding: 20px;
        font-size: 18px;
        text-align: center;
        color: white;
        a {
          color: white;
          text-decoration: none;
        }
        &:hover {
          background: #484848;
        }
        &.activeTab {
          background: #484848;
        }
      }
    }
  }
  .nav-menu {
    display: flex;
    gap: 37px;
    list-style: none;
    align-items: center;
    li {
      font-weight: 400;
      transition: 0.3s;
      cursor: pointer;
      :hover {
        color: var(--fontPrimaryColor);
      }
    }
    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }
  }
  .mobile-menu {
    font-size: 24px;
    cursor: pointer;
    transition: 0.3s;
    margin-top: 7px;
    z-index: 1000;
    .icon {
    }
    :hover {
      transform: scale(1.1);
    }
  }
  .closedModal {
    right: -200vw;
    position: fixed;
    transition: 0.4s;
  }
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    overflow-y: scroll;
    width: 400px;
    max-width: 440px;
    background: #303030;
    color: white;
    padding: 2em 14px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 10px 2px var(--shadowColor);
    transition: 0.4s ease-in-out;
    hr {
      border: none;
      border-bottom: 1px solid gray;
      margin-bottom: 10px;
    }
    .emptyCart {
      margin: 2em;
      .cartIcon {
        font-size: 4em;
        margin: auto;
        text-align: center;
      }
      h3 {
        margin-top: 10px;
        font-weight: 300;
        text-align: center;
        color: #ebe0d3;
      }
    }
    span {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 7px;
      div {
        display: flex;
        align-items: center;
        gap: 1em;
        .icon {
          color: white;
          font-size: 2em;
        }
        h3 {
          font-weight: 200;
        }
      }
      .x {
        color: white;
        background: none;
        border: none;
        font-size: 1.7em;
        position: absolute;
        right: 1em;
        cursor: pointer;
      }
    }
    .items {
      margin-top: 2em;
      .item {
        width: 100%;
        display: flex;
        gap: 1em;
        flex-direction: column;
        justify-content: space-between;
        img {
          width: 150px;
        }
        span {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          gap: 4px;
          h2 {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            h3 {
              font-size: 17px;
              font-weight: 400;
              width: 100%;
            }
            .icon {
              font-size: 1em;
              color: white;
            }
          }
          h4 {
            font-size: 17px;
            font-weight: 300;
            color: gray;
          }
          .quantity {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 4px;
            span {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 10px;
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                align-self: flex-start;
                font-size: 30px;
                width: 30px;
                height: 30px;
                border: none;
                background: white;
                color: black;
                cursor: pointer;
                border-radius: 8px;
              }
              h1 {
                font-weight: 300;
              }
            }
          }
        }
      }
    }
    .totalPrice {
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      font-weight: 400;
    }
    a {
      width: 100%;
      text-align: center;
      button {
        width: 100%;
        border: none;
        background: white;
        padding: 8px;
        font-size: 18px;
        border-radius: 4px;
        transition: 0.4s;
        cursor: pointer;
        &:hover {
          background: #c2c2c2;
        }
      }
    }
  }
  .link-styles {
    text-decoration: none;
    color: white;
    font-size: 18px;
  }
  @media only screen and (max-width: 768px) {
    .nav-menu {
      display: none;
    }
    .mobile-menu {
      display: block;
    }
    .nav-menu.active {
      display: flex;
      flex-direction: column;
      gap: 37px;
      position: fixed;
      top: 70px;
      left: 0;
      width: 100%;
      height: calc(100vh - 70px);
      background: var(--navbarColor);
      padding-top: 2em;
      z-index: 10;
      overflow: hidden;
    }
  }
  @media (max-width: 450px) {
    .logo {
      height: 45px;
    }
    .icons {
      gap: 8px;
      span {
        .icon {
          font-size: 1.7em;
          margin-top: 8px;
        }
        .cartIcon {
          font-size: 2em;
        }
        h4 {
          font-size: 12px;
          padding: 2px 5px;
        }
      }
    }
    .modal {
      width: 100%;
    }
  }
`;

export default Navbar;
